import { googleMapsApiKey } from '@/utils/googleMaps';
import { useJsApiLoader } from '@react-google-maps/api';

export default function useGoogleMaps() {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map',
    googleMapsApiKey: googleMapsApiKey,
  });

  return isLoaded;
}
